var $76eef57316a9e631$exports = {};
$76eef57316a9e631$exports = {
    "help": `\u{8AAA}\u{660E}`,
    "info": `\u{8CC7}\u{8A0A}`
};


export {$76eef57316a9e631$exports as default};
//# sourceMappingURL=zh-TW.mjs.map
